module.exports = __webpack_public_path__ + "img/ch69.027e2988.png";